import React, { Component } from 'react';
import { connect } from 'react-redux'
import { goBack } from 'react-router-redux'

class BackButton extends Component {
  constructor(props) {
    super(props)
  }

  onClick(e) {
    e.preventDefault()
    const { dispatch } = this.props
    dispatch(goBack())
  }

  render() {
    return (
       <i className='ionicons ion-arrow-return-left' style={{fontSize: '25px', color:'black', cursor:'Pointer'}} onClick={this.onClick.bind(this)}></i>
    );
  }
}

export default connect()(BackButton)




/** WEBPACK FOOTER **
 ** ./src/components/backButton.js
 **/